import { useState, useEffect } from 'react';

export default function FloatingAd() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentMessage, setCurrentMessage] = useState(0);
  
  const messages = [
    "5 dəqiqəyə öz vebsaytını yarat",
    "İndi online satışa başla"
  ];

  useEffect(() => {
    // İlk animasiya - 2 saniyə sonra görün
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(showTimer);
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    // Hər 8 saniyədə bir animasiya dövrü
    const cycleInterval = setInterval(() => {
      // Sağa get və yoxa çıx
      setIsVisible(false);
      
      // 2 saniyə sonra mesajı dəyiş və soldan geri gəl
      setTimeout(() => {
        setCurrentMessage(prev => (prev + 1) % messages.length);
        setIsVisible(true);
      }, 2000);
    }, 8000);

    return () => clearInterval(cycleInterval);
  }, [isVisible]);

  return (
    <>
      {/* WhatsApp Button - Reklamın tam arxasında */}
      <a
        href="https://wa.me/994557063190"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 bottom-8 z-40 w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110 group"
      >
        <svg className="w-9 h-9 text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
        
        {/* Pulse effect */}
        <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-75"></span>
      </a>

      {/* Floating Ad - Sağda, aşağıda */}
      <div
        className={`fixed right-0 bottom-8 z-50 transition-all duration-1000 ease-in-out ${
          isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
        }`}
      >
        <a
          href="/"
          className="group block bg-gradient-to-br from-black via-gray-800 to-black text-white px-5 py-4 rounded-l-2xl shadow-2xl hover:shadow-black/50 transition-all duration-300 hover:px-6"
        >
          {/* Yazı */}
          <div className="space-y-1 max-w-[160px]">
            <div className="text-xl font-bold leading-tight tracking-tight">
              I Veb
            </div>
            <div className="text-sm leading-tight text-gray-300 group-hover:text-white transition-colors">
              {messages[currentMessage]}
            </div>
          </div>

          {/* Arrow indicator */}
          <div className="absolute -left-3 top-1/2 -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-r-8 border-r-black border-b-8 border-b-transparent opacity-50 group-hover:opacity-100 transition-opacity"></div>
        </a>
      </div>

      {/* CSS for animations */}
      <style jsx>{`
        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .animate-spin-slow {
          animation: spin-slow 3s linear infinite;
        }
      `}</style>
    </>
  );
}
